import { useCallback, useEffect, useState } from 'react';

import DottedMap from 'dotted-map';

import { MAP_POINTS } from './pins';

const DottedMapComponent = ({
  isFromAsia
}: {
  productName: string;
  image: string;
  isFromAsia: boolean;
}) => {
  const [svgMap, setSvgMap] = useState('');

  const isWhiteColor = (color: string | null): boolean => {
    if (!color) return false;
    color = color.toLowerCase();

    return (
      color === '#ffffff' ||
      color === 'white' ||
      color === 'rgb(255,255,255)' ||
      color === 'rgba(255,255,255,1)' ||
      color === 'rgb(100%,100%,100%)'
    );
  };

  const processSvgMap = useCallback((svg: string) => {
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svg, 'image/svg+xml');
    const svgElement = svgDoc.documentElement;

    const circles = svgElement.querySelectorAll('circle');

    circles.forEach((circle) => {
      const fill = circle.getAttribute('fill')?.toLowerCase();
      const r = circle.getAttribute('r');

      if (isWhiteColor(fill || null)) {
        const cx = circle.getAttribute('cx');
        const cy = circle.getAttribute('cy');

        const g = svgDoc.createElementNS('http://www.w3.org/2000/svg', 'g');

        const staticCircle = circle.cloneNode(true) as SVGCircleElement;

        const increasedRadius = String(parseFloat(r || '0') * 1.2);

        staticCircle.setAttribute('r', increasedRadius);

        const animateStaticRadius = svgDoc.createElementNS(
          'http://www.w3.org/2000/svg',
          'animate'
        );

        animateStaticRadius.setAttribute('attributeName', 'r');
        animateStaticRadius.setAttribute(
          'values',
          `${increasedRadius}; ${parseFloat(r || '0') * 1.3}; ${increasedRadius}`
        );
        animateStaticRadius.setAttribute('dur', '2s');
        animateStaticRadius.setAttribute('repeatCount', 'indefinite');

        const beginOptions = [
          '0s',
          '0.25s',
          '0.5s',
          '0.75s',
          '1s',
          '1.25s',
          '1.5s',
          '1.75s',
          '2s',
          '2.25s',
          '2.5s',
          '2.75s',
          '3s'
        ];
        const randomBegin =
          beginOptions[Math.floor(Math.random() * beginOptions.length)];

        animateStaticRadius.setAttribute('begin', randomBegin);
        staticCircle.appendChild(animateStaticRadius);

        const auraCircle = svgDoc.createElementNS(
          'http://www.w3.org/2000/svg',
          'circle'
        );

        auraCircle.setAttribute('cx', cx || '0');
        auraCircle.setAttribute('cy', cy || '0');
        auraCircle.setAttribute('r', r || '0');
        auraCircle.setAttribute('fill', 'none');
        auraCircle.setAttribute('stroke', fill || '#000');
        auraCircle.setAttribute('stroke-width', '0.2');

        const maxRadius = String(parseFloat(r || '0') * 4);

        const animateRadius = svgDoc.createElementNS(
          'http://www.w3.org/2000/svg',
          'animate'
        );

        animateRadius.setAttribute('attributeName', 'r');
        animateRadius.setAttribute('from', r || '0');
        animateRadius.setAttribute('to', maxRadius);
        animateRadius.setAttribute('dur', '2s');
        animateRadius.setAttribute('repeatCount', 'indefinite');
        animateRadius.setAttribute('begin', randomBegin);

        const animateOpacity = svgDoc.createElementNS(
          'http://www.w3.org/2000/svg',
          'animate'
        );

        animateOpacity.setAttribute('attributeName', 'opacity');
        animateOpacity.setAttribute('from', '0.6');
        animateOpacity.setAttribute('to', '0');
        animateOpacity.setAttribute('dur', '2s');
        animateOpacity.setAttribute('repeatCount', 'indefinite');
        animateOpacity.setAttribute('begin', randomBegin);

        auraCircle.appendChild(animateRadius);
        auraCircle.appendChild(animateOpacity);

        g.appendChild(staticCircle);
        g.appendChild(auraCircle);

        circle.parentNode?.replaceChild(g, circle);
      } else {
        circle.setAttribute('r', '0.3');
      }
    });

    // Ensure SVG has width and height attributes
    if (!svgElement.getAttribute('width')) {
      svgElement.setAttribute('width', '100%');
    }
    if (!svgElement.getAttribute('height')) {
      svgElement.setAttribute('height', '100%');
    }
    svgElement.setAttribute('preserveAspectRatio', 'xMidYMid meet');

    const serializer = new XMLSerializer();

    return serializer.serializeToString(svgDoc);
  }, []);

  useEffect(() => {
    const asiaRegion = {
      lat: { min: -10, max: 55 },
      lng: { min: 25, max: 180 }
    };

    const worldRegion = {
      lat: { min: 0, max: 70 },
      lng: { min: -130, max: 140 }
    };

    const map = new DottedMap({
      height: isFromAsia ? 100 : 60,
      grid: 'vertical',
      region: isFromAsia ? asiaRegion : worldRegion
    });

    MAP_POINTS.forEach((pin) => {
      map.addPin({
        lat: pin.lat,
        lng: pin.lng,
        svgOptions: { color: '#FFFFFF', radius: 0.3 }
      });
    });

    const generatedSvgMap = map.getSVG({
      radius: 0.3,
      color: '#666EF5',
      shape: 'circle',
      backgroundColor: '#030DEF'
    });

    const processedSvgMap = processSvgMap(generatedSvgMap);

    setSvgMap(processedSvgMap);
  }, [isFromAsia, processSvgMap]);

  return (
    <div className="w-full h-full">
      <div
        className="w-full h-full"
        dangerouslySetInnerHTML={{ __html: svgMap }}
        style={{ display: svgMap ? 'block' : 'none' }}
      />
      {/* <div className="absolute top-4 left-4 flex items-center">
        {image ? (
          <div className="bg-white rounded-lg size-16 mr-2 flex justify-center items-center">
            <img
              src={image}
              alt="product quoting"
              className="size-12 rounded-lg"
            />
          </div>
        ) : (
          <div className="size-16 bg-white rounded-lg mr-2 flex justify-center items-center" />
        )}

        <h2 className="text-xl text-white font-c font-700">
          Finding suppliers for {productName}
        </h2>
      </div> */}
    </div>
  );
};

export default DottedMapComponent;
